import { useState } from 'react'
import { Dialog, DialogContent, DialogTrigger, SafeGuardStyle } from '../ModalStyled';
import { ModelWrapper } from '../Styled';
import { ReactComponent as SafeGuard } from 'assets/Icons/SafeGuard.svg';
import { ReactComponent as ModelBtn } from 'assets/Buttons/ModelBtn.svg';
import { Link } from "react-router-dom";
import axios from 'libs/axios';
import { toast } from 'react-toastify';
import { useForm, SubmitHandler } from 'react-hook-form';

const SignupModalDialog: any = ({ children, open, setOpen, email }) => {

    type Inputs = {
        email: string,
    };

    const { register, handleSubmit, getValues, formState: { errors } } = useForm<Inputs>();
    // const history = useHistory();
    const [loading, setLoading] = useState(true);

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/verify/resend-link', { email: email });
            toast.success(result.data.message);
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>

            <DialogTrigger asChild>
                {children}
            </DialogTrigger>

            <DialogContent>

                <SafeGuardStyle>
                    <SafeGuard />
                </SafeGuardStyle>

                <ModelWrapper>
                    <h2>Verify your Email</h2>
                    <p>We have sent a link to your Email<br></br>
                        Just click on the link in that email to complete your sign up</p>
                    <Link to='/'>Can’t find the email?</Link>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <button type='submit'>
                            <ModelBtn />
                        </button>
                    </form>
                </ModelWrapper>

            </DialogContent>
        </Dialog>
    )
}

export default SignupModalDialog;